import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  item: function item(state) {
    return state.item;
  },
  index: function index(state) {
    return state.index;
  },
  products: function products(state) {
    return state.products;
  },
  loading: function loading(state) {
    return state.loading;
  },
  items: function items(state) {
    return state.items;
  }
};